import { IDataArray, DataArray, AccountSetting } from './../index';

export class AccountSettingGroup implements IDataArray {
    public Id: number;
    public GroupName: string;
    public Order: number;

    public AccountSettings: DataArray<AccountSetting> = new DataArray<AccountSetting>(1);

    public GetById(): number {
        return this.Id;
    }
}
